import { Link } from "react-router-dom";
import { Stethoscope, Mail, Phone, MapPin, Star, Download } from "lucide-react";
export const Footer = () => {
  return <footer className="bg-card border-t border-border">
      <div className="container mx-auto px-4 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-2" aria-label="CheckFirst Care Home">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg gradient-hero" aria-hidden="true">
                <Stethoscope className="h-5 w-5 text-white" aria-hidden="true" />
              </div>
              <span className="text-xl font-bold text-foreground">CheckFirst</span>
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed">
              AI-powered healthcare triage platform helping patients make informed care decisions. 
              Real AI decision-making for effective care.
            </p>
            <p className="text-xs text-muted-foreground/80 mt-2">
              Founded by <Link to="/founder" className="text-primary hover:underline font-medium">Ranvir Gill</Link>
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h2 className="font-semibold text-foreground mb-4 text-base">Quick Links</h2>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-muted-foreground hover:text-primary transition-smooth text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/triage" className="text-muted-foreground hover:text-primary transition-smooth text-sm">
                  Symptom Checker
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-muted-foreground hover:text-primary transition-smooth text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-muted-foreground hover:text-primary transition-smooth text-sm">
                  Contact
                </Link>
              </li>
              <li>
                <a href="/install" className="text-muted-foreground hover:text-primary transition-smooth text-sm flex items-center gap-1">
                  <Download className="h-3 w-3" aria-hidden="true" />
                  Install App
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h2 className="font-semibold text-foreground mb-4 text-base">Legal</h2>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="text-muted-foreground hover:text-primary transition-smooth text-sm">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-muted-foreground hover:text-primary transition-smooth text-sm">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/hipaa-compliance" className="text-muted-foreground hover:text-primary transition-smooth text-sm">
                  HIPAA Compliance
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h2 className="font-semibold text-foreground mb-4 text-base">Contact</h2>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-muted-foreground text-sm">
                <Mail className="h-4 w-4" aria-hidden="true" />
                <span>ranvgill@haverford.org</span>
              </li>
              <li className="flex items-center space-x-2 text-muted-foreground text-sm">
                <Phone className="h-4 w-4" aria-hidden="true" />
                <span>+1-267 939 7923</span>
              </li>
              <li className="flex items-center space-x-2 text-muted-foreground text-sm">
                <MapPin className="h-4 w-4" aria-hidden="true" />
                <span>Healthcare Innovation District</span>
              </li>
              <li className="mt-4">
                <a 
                  href="https://share.google/uaiJskeVBY84MbYHz" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 hover:opacity-80 transition-smooth text-sm font-medium"
                >
                  <Star className="h-4 w-4 fill-primary text-primary" aria-hidden="true" />
                  <span className="text-foreground">Leave us a Google Review</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-muted-foreground text-sm">
              © 2024 CheckFirst. Founded by <Link to="/founder" className="text-primary hover:underline">Ranvir Gill</Link>. All rights reserved.
            </p>
            <p className="text-muted-foreground text-sm mt-2 md:mt-0">
              Not a substitute for professional medical advice.
            </p>
          </div>
        </div>
      </div>
    </footer>;
};